/**
stats-overview
*/


<template>
    <div>
        <p class="chart-title">Overview statistics describing the areas of interest and coverage of different MPA types.</p>

        <div id="area-overview"></div>
        <div id="mpa-overview"></div>

        <p style="font-size: 80%">Note: summing the area of the individual MPA types will result in a figure greater than the "In MPA" value - this is because some MPA types overlap with others. The "In MPA" value doesn't include any double counting.</p>
        <p style="font-size: 80%">Note: the area covered by Highly Protected Marine Areas (HPMAs) is very small compared to the other MPA types. You can zoom the chart to better see the differences.</p>

    </div>
</template>


<script>
import store from "../store/reality-check-store";


export default {
    name: "stats-overview",
    components: {},
    store,
    props: {
        stateChange: {type: Number, required: true}  // to trigger redraw
    },
    data: function () {
        return {}
    },
    methods: {
        drawAreaOverviewChart: function () {
            if (!document.getElementById("area-overview")) {
                return;  // stop redraws when tab hidden
            }

            const pieLayout = {
                // height: 600,
                // width: "100%",
                autosize: true,
                showlegend: false,
                // margin: {t: 60, r: 10, b: 20, l: 10},
                title: "Overall areas",
                labels: "none"
            }
            const data = this.areaOverviewData;

            if (document.getElementById("area-overview").offsetWidth > 500) {
                data.textinfo = "label+text"
            } else {
                data.textinfo = "text"
            }

            Plotly.newPlot("area-overview", [this.areaOverviewData], pieLayout, {responsive: true});
        },
        drawMpaOverviewChart: function () {
            Plotly.newPlot("mpa-overview", this.mpaOverviewData.data, {
                barmode: "stack", annotations: this.mpaOverviewData.annotations, showlegend: false,
                autosize: true,
                // width: "100%",
                margin: {
                    t: 60, r: 10, b: 40, l: 80
                },
                title: "MPAs",
                xaxis: {
                    // title: 'km<sup>2</sup>',
                    ticksuffix: " km<sup>2</sup>",
                    tickformat: ',.0f',
                    showticksuffix: "last"
                }
            }, {responsive: true})
        }
    },
    computed: {
        areaOverviewData: function () {
            return this.$store.state.stats.areaOverviewData
        },
        mpaOverviewData: function () {
            return this.$store.state.stats.mpaOverviewData
        }
    },
    watch: {
        areaOverviewData: function () {
            if (this.areaOverviewData) {
                this.drawAreaOverviewChart()
            }
        },
        mpaOverviewData: function () {
            if (this.mpaOverviewData) {
                this.drawMpaOverviewChart()
            }
        },
        stateChange: function () {
            this.drawAreaOverviewChart();
            this.drawMpaOverviewChart()
        }
    },
    mounted: function () {
        window.onresize =  function () {
            this.drawAreaOverviewChart();  // forces a redraw which also adjusts which text is displayed
        }.bind(this)
    }
}
</script>


<style lang="scss">
    @import "../../../styles/variables.scss";

    #area-overview, #mpa-overview {
        margin-bottom: 20px;
    }
</style>